import React from 'react';

import { useAppDispatcher } from 'hooks/useAppDispatcher';
import { useAppState } from 'hooks/useAppState';
import { useAsyncProcess } from 'hooks/useAsyncProcess';

export const useDemoStackCreationProcess = () => {
  const { demoStackUrl } = useAppState();

  const startProcess = useAsyncProcess();

  const dispatch = useAppDispatcher();

  React.useLayoutEffect(() => {
    if (demoStackUrl === null) {
      startProcess((services) =>
        services.createDemoStack().then(() => {
          dispatch({
            name: 'DemoStackCreated',
          });
        })
      );
    }
  }, [demoStackUrl, dispatch, startProcess]);
};
